import createPlugin from '@@/create-plugin';

export default createPlugin({
    components: {
        'html:code': () => import('./components/code'),
        'activate:editor': () => import('./components/activate')
    }
});
